import type { CustomerSheetReportVisitDto } from '@bhops/shared';
import { kstYmdHyphen } from './format-date';

// 고객사 리포트에 이어진 방문 일정을 사람에게 보일 때 — SO 번호가 아니라 날짜로(2026-11-03 오너).
// 화면의 기준은 리포트 번호다. 서버 문구(console-report.visitLabel)와 같은 표기.

/** '11/5' — 날짜가 없으면 null. */
export function visitMonthDay(visit: Pick<CustomerSheetReportVisitDto, 'scheduledFor'>) {
  const ymd = visit.scheduledFor ? kstYmdHyphen(visit.scheduledFor) : null;
  return ymd ? `${Number(ymd.slice(5, 7))}/${Number(ymd.slice(8, 10))}` : null;
}

/** '11/5 방문 일정' — 날짜가 없으면 '방문 일정'. */
export function visitLabel(visit: Pick<CustomerSheetReportVisitDto, 'scheduledFor'>) {
  const md = visitMonthDay(visit);
  return md ? `${md} 방문 일정` : '방문 일정';
}
